<template>
  <FlotoForm ref="form" @submit="applyChanges">
    <MRow
      class="bg-neutral-lightest rounded py-1 items-center border border-solid border-neutral-lighter"
    >
      <MCol class="pr-4 mt-4">
        <h5 class="inline-block"> {{ $tc('detected_date') }} </h5>
      </MCol>
      <MCol :size="4">
        <FlotoFormItem
          hide-message
          :label="`${$t('from')} ${$t('date')}`"
          :rules="{
            required: true,
            // eslint-disable-next-line
            max_date: data.toValue,
          }"
        >
          <FlotoDatePicker
            v-model="data.fromValue"
            :allow-clear="false"
            :max-date="data.toValue"
          />
        </FlotoFormItem>
      </MCol>
      <MCol :size="4">
        <FlotoFormItem
          hide-message
          :label="`${$t('to')} ${$t('date')}`"
          :rules="{
            required: true,
            // eslint-disable-next-line
            min_date: data.fromValue,
          }"
        >
          <FlotoDatePicker
            v-model="data.toValue"
            :allow-clear="false"
            :min-date="data.fromValue"
          />
        </FlotoFormItem>
      </MCol>
      <MCol auto-size class="mt-2">
        <MButton @click="submitForm">{{ $t('apply') }}</MButton>
      </MCol>
    </MRow>
    <template v-slot:submit>
      <span />
    </template>
  </FlotoForm>
</template>

<script>
export default {
  name: 'BaselineVarianceHistoryFilterPicker',
  model: { event: 'change' },
  props: {
    value: { type: Object, required: true },
  },
  data() {
    return {
      data: {
        ...this.value,
      },
      isError: false,
    }
  },
  watch: {
    value() {
      this.data = { ...this.value }
    },
  },
  methods: {
    submitForm() {
      this.$refs.form.submit()
    },
    applyChanges() {
      let data = {
        ...this.data,
      }
      this.$emit('change', data)
      this.$emit('close')
    },
  },
}
</script>
